"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ObjectId = require('bson').ObjectID;
var clone = require('clone');
var tv4 = require('tv4');
var Card = require('./card');
var CardOptionValue = require('./card-option-value');
var CheckboxCard = /*#__PURE__*/function (_Card) {
  _inherits(CheckboxCard, _Card);
  var _super = _createSuper(CheckboxCard);
  function CheckboxCard(opt) {
    var _this;
    _classCallCheck(this, CheckboxCard);
    _this = _super.call(this, opt);
    _this.type = 'CHECKBOX';
    _this.details = {
      name: null,
      countLabel: null,
      count: null,
      hideNotes: false,
      notes: null,
      optionsId: null,
      selectedOptions: []
    };
    if (opt && opt.details) {
      _this.fillObject(clone(opt.details));
    }
    return _this;
  }
  _createClass(CheckboxCard, [{
    key: "fillObject",
    value: function fillObject(details) {
      this.details.name = details.name || null;
      this.details.countLabel = details.countLabel || null;
      this.details.hideNotes = 'hideNotes' in details ? details.hideNotes : false;
      this.details.optionsId = details.optionsId ? new ObjectId(details.optionsId) : null;
      this.details.selectedOptions = details.selectedOptions ? details.selectedOptions.map(function (opt) {
        return new CardOptionValue(opt);
      }) : [];
      this.details.notes = details.notes || null;
      this.details.count = details.countLabel ? this.details.selectedOptions.reduce(function (acc, curr) {
        return acc + curr.count;
      }, 0) : null;
      this.isValid = !!this.details.selectedOptions.length;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, CheckboxCard.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'checkbox-card.schema.json',
        type: 'object',
        allOf: [{
          $ref: 'card.schema.json'
        }, {
          properties: {
            details: {
              name: {
                type: 'string'
              },
              countLabel: {
                type: ['string', 'null']
              },
              count: {
                type: ['number', 'null']
              },
              hideNotes: {
                type: 'boolean'
              },
              optionsId: {
                type: 'object'
              },
              selectedOptions: {
                type: 'array',
                items: {
                  $ref: 'card-option-value.schema.json'
                }
              },
              notes: {
                type: ['string', 'null']
              }
            }
          }
        }],
        required: Object.keys(this)
      };
    }
  }]);
  return CheckboxCard;
}(Card);
tv4.addSchema(Card.schema());
tv4.addSchema(CardOptionValue.schema());
module.exports = CheckboxCard;